import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';
import {Body} from 'shells/typography/body';

type Props = {
    shouldSyncContacts: boolean;
    shouldSyncMessages: boolean;
};

export function SyncConfirmation(props: Props) {
    let message;
    if (props.shouldSyncContacts && props.shouldSyncMessages) {
        message = 'Your contacts and message history will sync over the next few minutes.';
    } else if (props.shouldSyncContacts) {
        message = 'Your contacts will sync over the next few minutes.';
    } else if (props.shouldSyncMessages) {
        message = 'Your message history will sync over the next few minutes.';
    }

    return (
        <OnboardingBody title='You’re all done!'>
            <div className='mt-16'>
                <Body>{message}</Body>
            </div>
        </OnboardingBody>
    );
}
